'use client';

import { c as _c } from "react/compiler-runtime";
import { NumberEightIcon, NumberFiveIcon, NumberFourIcon, NumberNineIcon, NumberOneIcon, NumberSevenIcon, NumberSixIcon, NumberThreeIcon, NumberTwoIcon } from '@phosphor-icons/react';
const ICON_MAP = {
  1: NumberOneIcon,
  2: NumberTwoIcon,
  3: NumberThreeIcon,
  4: NumberFourIcon,
  5: NumberFiveIcon,
  6: NumberSixIcon,
  7: NumberSevenIcon,
  8: NumberEightIcon,
  9: NumberNineIcon
};
export function NumberIcon(t0) {
  const $ = _c(3);
  const {
    index,
    size: t1
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const Icon = ICON_MAP[index as keyof typeof ICON_MAP];
  if (!Icon) {
    return null;
  }
  let t2;
  if ($[0] !== Icon || $[1] !== size) {
    t2 = <Icon size={size} />;
    $[0] = Icon;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}